import styled from 'styled-components'
import { colours } from '@qflow/theme'

export const isMatchStatus = (status: string) =>
  `${status || ''}`.trim().toLowerCase() === 'match'

export const StatusCapsule = styled.span<{ $isMatch: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 999px;
  padding: 0.125rem 0.625rem;
  font-weight: 500;
  background-color: ${({ $isMatch }) =>
    $isMatch ? colours.PALE_GREEN : colours.CONSTRUCTION_ORANGE_BACKGROUND};
  color: ${({ $isMatch }) =>
    $isMatch ? colours.SUCCESS : colours.ORANGE_TEXT};
`
